/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { AdditionalCostsDto } from '../../models/additional-costs-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface UpdateAdditionalCost$Params {
  additionalCostId: number;
  body: AdditionalCostsDto;
}

export function updateAdditionalCost(
  http: HttpClient,
  rootUrl: string,
  params: UpdateAdditionalCost$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<AdditionalCostsDto>> {
  const rb = new RequestBuilder(rootUrl, updateAdditionalCost.PATH, 'put');
  if (params) {
    rb.path('additionalCostId', params.additionalCostId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdditionalCostsDto>;
    }),
  );
}

updateAdditionalCost.PATH = '/service/v1/afterSales/additionalCosts/{additionalCostId}';
